import React from 'react';
import ClickHandler from '@nykaa/deals-utils/clicks';
import { webActionTypes, } from '@nykaa/deals-utils/clicks/constants';
import styled from '../../theme';
import WidgetTitle from './widgetTitle';
const Wrapper = styled.div `
  padding-bottom: 5px;
  padding-top: 5px;
  margin-bottom: ${({ isDesktop }) => (isDesktop ? '16px' : 'auto')};
  text-align: ${({ align }) => align};
  background-color:${({ color, isFullWidth }) => (isFullWidth ? color : 'transparent')};

  .fixed-width-wrapper  {
    margin: 0 auto;
    max-width: 1140px;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;
const ListWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  margin-left: ${({ isDesktop }) => (isDesktop ? '-10px' : 'auto')};
  margin-right: ${({ isDesktop }) => (isDesktop ? '-10px' : 'auto')};
  @media ${(props) => props.theme.mq.md} { 
    align-items: flex-start;
    justify-content: center;
  }
`;
const ColumnWrapper = styled.div `
  display: inline-flex;
  box-sizing: border-box;
  width: ${({ width }) => width}%;
  vertical-align: top;
  padding: ${({ isDesktop }) => (isDesktop ? '10px' : '5px 7px')};
  position: relative;
  @media ${(props) => props.theme.mq.md} { 
    display: inline-block;
  }
`;
const SubTitle = styled.h3 `
  letter-spacing: 0.3px;
  color: rgba(3, 2, 26, 0.8);
  display: block;
  font-weight: 600;
  margin: ${({ isDesktop }) => (isDesktop ? '5px auto 5px' : '5px 10px 10px 10px')};
  max-width: 1140px;
`;
const ViewAllCTA = styled.button `
    padding: 5px 10px;
    margin-top: -32px;
    margin-right: 10px;
    background: transparent;
    border: none;
    font-size: 14px;
    letter-spacing: 1.1px;
    color: red;
    float: right;
    color: #fc2779;
    cursor: pointer;  

    @media ${(props) => props.theme.mq.md} { 
      &::after {
        content: '';
        background-image: url(https://adn-static1.nykaa.com/uploads/dde85e97-9102-4d97-8477-83659e8bb4b9.png);
        background-repeat: no-repeat;
        background-size: contain;
        text-align: center;
        width: 6.9px;
        height: 12px;
        display: inline-block;
        margin-left: 10px;
      }
    }
`;
const ColumnGrid = (widgetData) => {
    const { params, children, isDesktop, } = widgetData;
    const { title, subTitle, titleAlign, columnsInRow = 1, imageUrl, viewAllUrl, backGroundColor, isFullWidth, appLinkData, appLinkType, } = params;
    const clickHandler = (event) => {
        event.preventDefault();
        ClickHandler.handleClick({
            appLinkData,
            appLinkType,
            webActionType: webActionTypes.URL_REDIRECTION,
            webActionUrl: viewAllUrl,
            isDesktop,
        });
    };
    const columnWidth = (100 / columnsInRow);
    return (React.createElement(Wrapper, { align: titleAlign, color: backGroundColor, isDesktop: isDesktop, isFullWidth: isFullWidth },
        imageUrl && (React.createElement("img", { src: imageUrl, alt: title })),
        title && (React.createElement(WidgetTitle, { title: title, isDesktop: isDesktop })),
        subTitle && (React.createElement(SubTitle, { isDesktop: isDesktop }, subTitle)),
        (isDesktop && viewAllUrl) && (React.createElement("div", { className: "fixed-width-wrapper" },
            React.createElement(ViewAllCTA, { type: "button", onClick: clickHandler }, "VIEW ALL"))),
        React.createElement("div", { className: "fixed-width-wrapper" },
            React.createElement(ListWrapper, { isDesktop: isDesktop }, children && children.map((column) => (React.createElement(ColumnWrapper, { key: `${column.key}_colWrap`, width: columnWidth, isDesktop: isDesktop }, column)))))));
};
export default ColumnGrid;
